import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import { fetchNearestGymsData } from "../../redux/website-reducers/websiteSlice";
import GymSlugListings from "../../components/website-contents/gym-listings/GymSlugListings";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const GymLandingListings = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function getGymLandingPagesList(filters) {
    dispatch(
      fetchNearestGymsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getGymLandingPagesList(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedGym]);

  return (
    <HelmetWrapper title="WTF: Gym Landing Pages">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gym Landing Pages"}
              isReload={() => getGymLandingPagesList(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"gym-landing-pages"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <GymSlugListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymLandingListings;
